import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { FieldType } from "@shared/features/form/Form";
import {
  contactSchemaBaseFields,
  withEmailConfirmationValidation,
} from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { FormDialog } from "@shared/features/form/FormDialog";
import { marketingEventBus } from "../../marketing.events";

export function HireUsDialog() {
  const schema = withEmailConfirmationValidation(
    z.object({
      ...contactSchemaBaseFields,
      organization: z.string().min(1, "Organization is required"),
    })
  );

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
    "organization",
    "message",
  ]);

  const submitForm = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      try {
        marketingEventBus.emitEvent("hireUs:submit", data);

        return await apiRequest(
          "/api/form-submission-proxy/",
          "POST",
          {
            first_name: data.firstName,
            last_name: data.lastName,
            ...data,
            form_type: "hire_us",
          },
          false,
          undefined,
          "platform"
        );
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data, variables) => {
      marketingEventBus.emitEvent("hireUs:success", variables);
    },
  });

  return (
    <FormDialog
      dialogName="hireUs"
      title="Hire Us"
      description="Get in touch to learn more about our rates and services."
      successTitle="Success!"
      successDescription="Thank you for your interest in working with us. We'll be in touch soon."
      schema={schema}
      fields={fields as FieldType[]}
      onSubmit={submitForm.mutateAsync}
    />
  );
}

export default HireUsDialog;
